import { z } from 'zod'
import { parametermDataSchema } from './parameterm-data'

/**
 * 參數類別 - 新增 Request Schema
 */
export const createParametermRequestSchema = parametermDataSchema

/**
 * 參數類別 - 新增 Request
 */
export interface CreateParametermRequest
  extends z.infer<typeof createParametermRequestSchema> {}
